@if (canTransferManager) {
  <div class="d-flex w-100 align-items-center justify-content-center">
    <button class="btn py-1 px-2 btn-danger text-uppercase btn-transfer-manager" (click)="transfer()">
      {{ 'Transfer_Original_Ownership' | translate }}
    </button>
  </div>
}

@if (canTransfer) {
  <div class="d-flex w-100 align-items-center justify-content-center">
    <button class="btn py-1 px-2 btn-danger text-uppercase btn-transfer" (click)="transfer()">
      {{ 'projectOwnershipTransfer_transfer' | translate }}
    </button>
  </div>
}
